import { Empty, IWork, WorkCard, WorkCardContainer } from '@diana/core';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { PERFORMANCE_PAGE_NS } from './i18n';
import { useTranslation } from 'react-i18next';
import { Board } from '../../components/Board/Board';

const CardHeight = 228;

export function DataExplorerReportBoard(props: {
  works: IWork[];
  isLoading: boolean;
  environment: string;
  isFetching: boolean;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
}) {
  const { t } = useTranslation(PERFORMANCE_PAGE_NS);
  const {
    works,
    environment,
    isLoading,
    isFetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = props;

  return (
    <Board<IWork>
      items={works}
      itemHeight={CardHeight}
      isLoading={isLoading}
      isFetching={isFetching}
      isFetchingNextPage={isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      EmptyComponent={<Empty>{t('grid.empty')}</Empty>}
      renderItem={({ item }) => (
        <WorkCardContainer key={item.id}>
          <WorkCard href={routeUrls.work.url({ environment, workId: item.id }, {})} work={item} />
        </WorkCardContainer>
      )}
    />
  );
}
